import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet"
import ReactGA from 'react-ga4';

import Home from './pages/Home'
import Navbar from './components/Navbar';
import Footer from './components/Footer';


import { Hilfe, Guide, Impressum, Datenschutz } from './pages';

import Popup from './components/popup';

const TRACKING_ID = "G-003QP8QELS";

function App() {

  return (
    <div className="App bg-neutral-200">
      <BrowserRouter>

        <Popup onAcceptCookies={() =>{ ReactGA.initialize(TRACKING_ID); ReactGA.send("pageview");}}/>

        <Helmet>
          <title>Online Rechnung Erstellen! | Kostenlos Sofort Download!</title>
        </Helmet>

        <Navbar />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/hilfe" element={<Hilfe />} />
          <Route path="/rechnungen-richtig-schreiben" element={<Guide />} />

          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
        </Routes>

        <Footer />

      </BrowserRouter>
    </div>
  );
}

export default App;
